module.exports = __webpack_public_path__ + "static/media/IMG_7340.fbe587c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/square/IMG_7340.jpg
// module id = 118
// module chunks = 0